//
//
//
//

import { PropsMixin } from '../mixins';
export default {
  mixins: [PropsMixin],
};
